export const get_EarliestItem = (data) =>
  data.reduce((a, b) =>
    new Date(`${a.date}T${a.time}`) > new Date(`${b.date}T${b.time}`) ? b : a
  );

export const get_LatestItem = (data) =>
  data.reduce((a, b) =>
    new Date(`${a.date}T${a.time}`) < new Date(`${b.date}T${b.time}`) ? b : a
  );

export function map_ValueDate(array) {
  return array.map((item) => {
    return {
      value: 0,
      xIndex: item,
    };
  });
}

export const get_NumberArrayWithinRange = (start, end) => {
  let array = [];

  for (let i = start; i <= end; i++) {
    array.push(i);
  }

  return array;
};

export const getParamString = (array) => {
  let param = "";

  for (let [key, value] of array) {
    param += `${key}=${value}&`;
  }

  param = param.slice(0, -1);

  return `?${param}`;
};
